import { t } from "@auto/services";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

import styles from "./tagtypes.module.styl";

export const TAG_TYPES = Object.freeze({
  default: {
    label: t("geo.tag"),
    icon: LocalOfferIcon,
    className: styles.tagDefault,
    defaultValue: true
  }
});

export default TAG_TYPES;